(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1847],{

/***/ 1060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _param_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/withPage.js
var withPage = __webpack_require__(68262);
// EXTERNAL MODULE: ./src/components/category/CategoryBreadCrumb/index.jsx
var CategoryBreadCrumb = __webpack_require__(63928);
// EXTERNAL MODULE: ./src/components/category/Reviews/index.jsx + 2 modules
var Reviews = __webpack_require__(61874);
// EXTERNAL MODULE: ./src/components/category/Services/index.js
var Services = __webpack_require__(83407);
// EXTERNAL MODULE: ./src/components/category/WhyBulletPoints/index.js + 5 modules
var WhyBulletPoints = __webpack_require__(65727);
// EXTERNAL MODULE: ./src/components/page.jsx + 1 modules
var page = __webpack_require__(13366);
// EXTERNAL MODULE: ./src/redux/actions/index.js + 7 modules
var actions = __webpack_require__(89703);
// EXTERNAL MODULE: ./src/redux/actions/geolocation.js
var geolocation = __webpack_require__(47571);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 7 modules
var react_select_esm = __webpack_require__(19154);
;// CONCATENATED MODULE: ./src/static/images/category-search-bg.jpg
/* harmony default export */ var category_search_bg = ({"src":"/_next/static/media/category-search-bg.c707c85d.jpg","height":761,"width":1999,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAbEAACAgMBAAAAAAAAAAAAAAAAAQIEBREVUf/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAVEQEBAAAAAAAAAAAAAAAAAAAAMf/aAAwDAQACEQMRAD8Ah3cpOrqVybSXiAA8G//Z","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./src/components/category/CategorySearch/index.jsx











var selectStyles = {
    menu: function(styles) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, styles), {
            zIndex: 9999
        });
    }
};
var customStyles = {
    menuList: function(provided, state) {
        return (0,_object_spread/* default */.Z)({}, provided);
    },
    control: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            background: "#fff",
            minHeight: "40px",
            height: "40px",
            borderRadius: "3px",
            borderWidth: "2px"
        });
    },
    valueContainer: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            height: "40px"
        });
    },
    input: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            margin: "0px"
        });
    },
    indicatorsContainer: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            height: "40px"
        });
    }
};
var customStylesActive = {
    menuList: function(provided, state) {
        return (0,_object_spread/* default */.Z)({}, provided);
    },
    control: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            background: "#fff",
            minHeight: "40px",
            height: "40px",
            borderRadius: "3px",
            borderWidth: "2px",
            borderColor: "#96cb57"
        });
    },
    valueContainer: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            height: "40px",
            color: "green"
        });
    },
    input: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            margin: "0px"
        });
    },
    placeholder: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            fontWeight: "600",
            color: "#96cb57"
        });
    },
    indicatorsContainer: function(provided, state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided), {
            height: "40px"
        });
    }
};
var CategorySearch = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(CategorySearch, Component);
    var _super = (0,_create_super/* default */.Z)(CategorySearch);
    function CategorySearch() {
        (0,_class_call_check/* default */.Z)(this, CategorySearch);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CategorySearch, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, type = _props.type, names = _props.names, dropdownCategories = _props.dropdownCategories, formTitle = _props.formTitle, updatingOptionId = _props.updatingOptionId, application = _props.application, imageUrl = _props.imageUrl;
                var lastIndexAvailable = dropdownCategories.length - 1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "category-search ".concat(type, " "),
                    style: {
                        background: "#395e95 url(".concat(category_search_bg, ") center center")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inner-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(type === "cover" ? "container" : ""),
                            children: [
                                type === "cover" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "brand",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "100px",
                                        height: "100px",
                                        src: imageUrl,
                                        alt: "category"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "form",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "form-items",
                                        children: names.map(function(item, index) {
                                            var selectedId = application ? application[index] : null;
                                            var selectedItem = null;
                                            if (dropdownCategories[index] && selectedId) {
                                                selectedItem = dropdownCategories[index].find(function(el) {
                                                    return el.id == selectedId.id;
                                                });
                                            }
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "\n                        form-item \n                        ".concat(!dropdownCategories[index] ? "disabled" : "", "\n                        ").concat(updatingOptionId === index ? "loading" : "", "\n                        ").concat(lastIndexAvailable === index ? "last-index-available" : "", "\n                      "),
                                                children: [
                                                    updatingOptionId === index && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "loading-container",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "inner",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fas fa-circle-notch fa-spin mr-2"
                                                                }),
                                                                " Loading..."
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm/* default */.ZP, {
                                                        styles: lastIndexAvailable === index ? customStylesActive : customStyles,
                                                        defaultValue: selectedItem,
                                                        value: selectedItem,
                                                        isDisabled: !dropdownCategories[index],
                                                        id: "select-".concat(item),
                                                        closeMenuOnSelect: true,
                                                        blurInputOnSelect: true,
                                                        getOptionLabel: function(param) {
                                                            var name = param.name;
                                                            return name;
                                                        },
                                                        getOptionValue: function(param) {
                                                            var id = param.id;
                                                            return id;
                                                        },
                                                        options: dropdownCategories[index],
                                                        placeholder: item,
                                                        onChange: function(value) {
                                                            _this.props.onSelectionChange(value, index);
                                                        }
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                })
                            ]
                        })
                    })
                });
            }
        }
    ]);
    return CategorySearch;
}(react.Component);
/* harmony default export */ var category_CategorySearch = (CategorySearch);

// EXTERNAL MODULE: ./src/components/category/LocationRequiredOverlay/index.jsx
var LocationRequiredOverlay = __webpack_require__(76216);
// EXTERNAL MODULE: ./node_modules/react-responsive-modal/dist/react-responsive-modal.esm.js + 3 modules
var react_responsive_modal_esm = __webpack_require__(31190);
// EXTERNAL MODULE: ./src/components/home/PlacesSearch/index.jsx + 2 modules
var PlacesSearch = __webpack_require__(69174);
;// CONCATENATED MODULE: ./src/components/modals/UpdateLocationModal.jsx




var LocationModal = function(param) {
    var open = param.open, hideModal = param.hideModal, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_modal_esm/* default */.Z, {
        open: open,
        onClose: function() {
            return hideModal();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "update-location-modal",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                    children: title ? title : "Update Your Location - Required"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "place-selection",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlacesSearch/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "alert alert-primary mt-3",
                    role: "alert",
                    children: "Location is required because prices, taxes, product availability, and the type of service are dependent on where you are located. If you have any questions please contact us."
                })
            ]
        })
    });
};
/* harmony default export */ var UpdateLocationModal = (LocationModal);

// EXTERNAL MODULE: ./src/utils/geolocation.js
var utils_geolocation = __webpack_require__(53427);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/category/[...param].jsx























// Code Splitting of optional renders...
var Collection = dynamic_default()(Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(6672), __webpack_require__.e(7206), __webpack_require__.e(8013), __webpack_require__.e(5604), __webpack_require__.e(9180), __webpack_require__.e(1310), __webpack_require__.e(4762), __webpack_require__.e(949), __webpack_require__.e(6088), __webpack_require__.e(9232), __webpack_require__.e(1495), __webpack_require__.e(1223)]).then(__webpack_require__.bind(__webpack_require__, 35074)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35074)
            ];
        }
    }
});
var CollectionTitle = dynamic_default()(__webpack_require__.e(/* import() */ 839).then(__webpack_require__.bind(__webpack_require__, 20839)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20839)
            ];
        }
    }
});
var FeaturedCategoryItems = dynamic_default()(__webpack_require__.e(/* import() */ 9213).then(__webpack_require__.bind(__webpack_require__, 79213)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79213)
            ];
        }
    }
});
var LicensePlate = dynamic_default()(__webpack_require__.e(/* import() */ 1253).then(__webpack_require__.bind(__webpack_require__, 61253)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61253)
            ];
        }
    }
});
var CategoryItems = dynamic_default()(__webpack_require__.e(/* import() */ 4063).then(__webpack_require__.bind(__webpack_require__, 74063)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74063)
            ];
        }
    }
});
var queryString = __webpack_require__(17563);
var urlLength;





var Category = /*#__PURE__*/ function(Page) {
    "use strict";
    (0,_inherits/* default */.Z)(Category, Page);
    var _super = (0,_create_super/* default */.Z)(Category);
    function Category(props) {
        (0,_class_call_check/* default */.Z)(this, Category);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleOnChange", function(item) {
            var path = "/category/".concat(item.urlRedirect != null ? item.urlRedirect : item.urlSlug);
            if (_this.props.crit) {
                path = "".concat(path, "?crit=").concat(_this.props.crit);
            }
            router_default().push("/category/[categoryid]?categoryid=".concat(item.urlRedirect != null ? item.urlRedirect : item.urlSlug), path).then(function() {
                if (window) {
                    window.scrollTo(0, 0);
                }
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "handleOnSelectionChange", function(item, index) {
            var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
            _this.setState({
                updatingOptionId: index
            });
            var path = "/category/".concat(item.urlRedirect != null ? item.urlRedirect : item.urlSlug);
            if (_this.props.crit) {
                path = "".concat(path, "?crit=").concat(_this.props.crit);
            }
            router_default().push("/category/[categoryid]?categoryid=".concat(item.urlRedirect != null ? item.urlRedirect : item.urlSlug), path).then(function() {
                if (window) {
                    window.scrollTo(0, 0);
                }
                _this1.setState({
                    updatingOptionId: null
                });
            });
        });
        _this.toggle = _this.toggle.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            childCategories: [],
            collapse: false,
            isLoadingCategory: true,
            IsLicensePlateOpen: false,
            updatingOptionId: null,
            showAllMakes: true,
            showAddressModal: false,
            showMobileReviews: true,
            showReviews: true,
            masterProvider: null,
            visibleQuickSearchTab: "initial"
        };
        _this.handleOnChange = _this.handleOnChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(Category, [
        {
            key: "toggle",
            value: function toggle() {
                this.setState(function(state) {
                    return {
                        collapse: !state.collapse
                    };
                });
            }
        },
        {
            key: "toggleLicensePlate",
            value: function toggleLicensePlate(type) {
                console.log(type, this.state);
                this.setState(function(state) {
                    return {
                        visibleQuickSearchTab: type
                    };
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var _props, updateGeolocation, geolocationPayload;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Get initial window location href
                                urlLength = window.location.href.length;
                                if (window) {
                                    window.scrollTo(0, 0);
                                }
                                _props = _this.props, updateGeolocation = _props.updateGeolocation, geolocationPayload = _props.geolocationPayload;
                                if (!updateGeolocation) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.props.setLocation(geolocationPayload)
                                ];
                            case 1:
                                _state.sent();
                                _this.setState({
                                    isLoadingCategory: true
                                });
                                // FIXME: Causes Side Effects - Need to Figure out  to Allow for GeoLocation to Update Address selection in // Works Correct in Product...
                                return [
                                    4,
                                    _this.props.getCategoryProps(_this.props.categoryid)
                                ];
                            case 2:
                                _state.sent();
                                _this.setState({
                                    isLoadingCategory: false
                                });
                                _state.label = 3;
                            case 3:
                                _this.setState({
                                    isLoadingCategory: false,
                                    updateGeolocation: false
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var ref, ref1;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(prevProps.geolocation !== _this.props.geolocation && !_this.state.isLoadingCategory == true && _this.props.geolocation.latitude && (_this.props.geolocation.latitude !== prevProps.geolocation.latitude || _this.props.geolocation.longitude !== prevProps.geolocation.longitude) || _this.props.priceLevel !== prevProps.priceLevel || _this.props.priceLevel && !prevProps.priceLevel)) return [
                                    3,
                                    2
                                ];
                                _this.setState({
                                    isLoadingCategory: true
                                });
                                return [
                                    4,
                                    _this.props.getCategoryProps(_this.props.categoryid)
                                ];
                            case 1:
                                _state.sent();
                                _this.setState({
                                    isLoadingCategory: false
                                });
                                _state.label = 2;
                            case 2:
                                if (((ref = prevProps.masterProvider) === null || ref === void 0 ? void 0 : ref.name) !== ((ref1 = _this.props.masterProvider) === null || ref1 === void 0 ? void 0 : ref1.name)) {
                                    _this.setState({
                                        showReviews: !_this.props.masterProvider.isActive
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "renderMainArea",
            value: function renderMainArea() {
                var _this = this;
                var _props = this.props, category = _props.category.category, childCategories = _props.childCategories, categoryid = _props.categoryid, geolocation = _props.geolocation, shop = _props.shop, breadcrumbs = _props.breadcrumbs, featuredCategories = _props.featuredCategories, CurrentIndex = _props.CurrentIndex, products = _props.products, application = _props.application, applicationLabel = _props.applicationLabel, currentLevelQuery = _props.currentLevelQuery;
                var showReviews = this.state.showReviews;
                var fullCategoryName = "";
                this.props.breadcrumbs.forEach(function(element, index) {
                    if (_this.props.breadcrumbs.length <= 3) {
                        if (index >= 1) {
                            fullCategoryName = fullCategoryName + (index === 2 ? " for " : " ") + element.name;
                        }
                    } else {
                        if (index != 0 && index != 2) {
                            fullCategoryName = fullCategoryName + (index === 3 ? " for " : " ") + element.name;
                        }
                    }
                });
                var imageUrl = null;
                // Parse out Image in any layer to assign to forward section.
                for(var x = 0; x <= breadcrumbs.length; x++){
                    if (x >= 2) {
                        for(var z = 0; Array.isArray(childCategories) && z < childCategories.length && childCategories.length > 0 && breadcrumbs[x]; z++){
                            if (childCategories[z] && childCategories[z].length > 0 && breadcrumbs[x] && breadcrumbs[x].id) {
                                var ref;
                                var imageIndex = (ref = childCategories[z]) === null || ref === void 0 ? void 0 : ref.map(function(e) {
                                    return e.id;
                                }).indexOf(parseInt(breadcrumbs[x].id));
                                if (imageIndex >= 0) {
                                    imageUrl = childCategories[z][imageIndex].imageUrl ? childCategories[z][imageIndex].imageUrl : imageUrl;
                                }
                            }
                        }
                    }
                }
                var rows = [];
                var SearchName = "";
                var CurrentLevel = applicationLabel + " " + currentLevelQuery;
                var ViewAllLabel = childCategories[CurrentIndex] ? "View All Items(" + childCategories[CurrentIndex].length + ")" : "";
                var IsOpen = this.state.collapse;
                if (featuredCategories[CurrentIndex] && featuredCategories[CurrentIndex].length > 0 ? false :  true && !IsOpen) {
                    IsOpen = true;
                }
                var showImagesNonFeatured = true;
                if (featuredCategories[CurrentIndex] && featuredCategories[CurrentIndex].length > 0) {
                    showImagesNonFeatured = false;
                }
                var SortBy = "Asc";
                var names = [];
                var sortings = [];
                if (category.showDropDownSearch) {
                    if (category.dropDownSearchNames) {
                        names = category.dropDownSearchNames.split(",");
                        sortings = category.dropDownSearchSortOrder.split(",");
                        SearchName = names[CurrentIndex];
                        SortBy = sortings[CurrentIndex] ? sortings[CurrentIndex] : "Asc";
                    }
                    ViewAllLabel = childCategories[CurrentIndex] ? "View All " + SearchName + "s(" + childCategories[CurrentIndex].length + ")" : "";
                    var index = breadcrumbs.map(function(e) {
                        return e.id;
                    }).indexOf(category.id.toString());
                    for(var i = 0; i < names.length; i++){
                        var currentvalue = (breadcrumbs[index + i + 1] ? breadcrumbs[index + i + 1].id : 0).toString(); // Match Variable type to string
                        var loadvalue = (breadcrumbs[index + i] ? breadcrumbs[index + i].id : 0).toString();
                    }
                }
                var groupByAlphaFilter = (0,Services/* groupByAlpha */.q)(childCategories[CurrentIndex], SortBy);
                var showMobileReviews = showReviews && urlLength && urlLength === window.location.href.length;
                var showDescription = showReviews;
                var productslength = products ? products.length ? products.length : 0 : 0;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "category-elements-container",
                        children: productslength > 0 && childCategories[CurrentIndex].length <= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Collection, {
                            reviews: this.props.reviews,
                            geolocation: geolocation,
                            products: products,
                            label: applicationLabel,
                            applicationSlug: categoryid,
                            provider: this.props.provider,
                            setSelectedProvider: this.props.setSelectedProvider,
                            showBuyButton: true,
                            analytics: this.props.analytics,
                            locationRequired: this.props.IsLocationRequired,
                            isUpdating: this.state.isLoadingCategory,
                            imageUrl: imageUrl,
                            productServices: this.props.productServices,
                            masterProvider: this.props.masterProvider,
                            isFeatured: false,
                            externalrequest: this.props.roadside
                        }) : // If we don't have products means we're still on the filtering step
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "category-elements internal",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container",
                                children: [
                                    showMobileReviews && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "mobile-disclaimer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text",
                                                children: "We Come to Your Location and Provide Our Expertise with Stellar Results"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews["default"], {
                                                reviews: this.props.reviews,
                                                type: "dropdown"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: fullCategoryName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "please-select",
                                        children: [
                                            "Please Select your",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: category.id ? category.id == 2 || category.id === 205712 ? CurrentLevel : "" : ""
                                            }),
                                            " ",
                                            "from Below:"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(showReviews ? "col-lg-9 main-content" : "col-lg-12"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "group",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "categories-grid-container",
                                                        children: [
                                                            !geolocation.latitude /* && productslength > 0  */  && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationRequiredOverlay/* default */.Z, {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: !geolocation.latitude /* && productslength > 0 */  && "shortened",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(category_CategorySearch, {
                                                                        updatingOptionId: this.state.updatingOptionId,
                                                                        formTitle: "Please Select your ".concat(category.name, " Need"),
                                                                        type: "horizontal",
                                                                        dropdownCategories: childCategories,
                                                                        application: application,
                                                                        names: names,
                                                                        onSelectionChange: this.handleOnSelectionChange,
                                                                        analytics: this.props.analytics,
                                                                        imageUrl: imageUrl
                                                                    }),
                                                                    this.renderLicensePlate(),
                                                                    featuredCategories[CurrentIndex] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedCategoryItems, {
                                                                        SearchName: SearchName,
                                                                        categoryIndex: CurrentIndex,
                                                                        categories: featuredCategories[CurrentIndex],
                                                                        ViewAllLabel: ViewAllLabel,
                                                                        clickHandle: this.handleOnChange,
                                                                        toggleHandle: function() {
                                                                            return _this.setState({
                                                                                showAllMakes: !_this.state.showAllMakes
                                                                            });
                                                                        },
                                                                        SortBy: SortBy,
                                                                        analytics: this.props.analytics
                                                                    }) : "",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: this.state.showAllMakes ? "visible" : "hidden",
                                                                        children: childCategories[CurrentIndex] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryItems, {
                                                                            IsOpen: IsOpen,
                                                                            groupByAlphaFilter: groupByAlphaFilter,
                                                                            SearchName: SearchName,
                                                                            categoryIndex: CurrentIndex,
                                                                            categories: childCategories[CurrentIndex],
                                                                            SortBy: SortBy,
                                                                            clickHandle: this.handleOnChange,
                                                                            analytics: this.props.analytics,
                                                                            showImages: showImagesNonFeatured
                                                                        }) : ""
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            showReviews && /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                                                className: "col-lg-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "sidebar",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews["default"], {
                                                        reviews: this.props.reviews,
                                                        type: "vertical"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                });
            }
        },
        {
            key: "renderBreadCrumb",
            value: function renderBreadCrumb() {
                var _props = this.props, category = _props.category, breadcrumbs = _props.breadcrumbs;
                if (!category | !breadcrumbs) return "";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBreadCrumb/* default */.Z, {
                    category: category,
                    breadcrumbs: breadcrumbs
                });
            }
        },
        {
            key: "renderLicensePlate",
            value: function renderLicensePlate() {
                var _this = this;
                var _props = this.props, category = _props.category, breadcrumbs = _props.breadcrumbs, products = _props.products;
                var productslength = products ? products.length ? products.length : 0 : 0;
                if (!category || productslength > 0) return "";
                if (category.category.id !== 2) return "";
                if (this.props.countries.length == 0) {
                    return "";
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "model-unknown-disclaimer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "text",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "far fa-info-circle"
                                                }),
                                                " ",
                                                "Quick Search by: "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "link",
                                            onClick: function() {
                                                return _this.toggleLicensePlate("license");
                                            },
                                            children: "License Plate"
                                        }),
                                        " or ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "link",
                                            onClick: function() {
                                                return _this.toggleLicensePlate("vin");
                                            },
                                            children: "VIN Number"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LicensePlate, {
                            changeVisibility: function(value) {
                                return _this.toggleLicensePlate(value);
                            },
                            visibleQuickSearchTab: this.state.visibleQuickSearchTab,
                            countries: this.props.countries,
                            geolocation: this.props.geolocation,
                            setVin: function(vin) {
                                return _this.props.setVin(vin);
                            },
                            analytics: this.props.analytics,
                            togglefunction: this.toggleLicensePlate.bind(this)
                        })
                    ]
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, category = _props.category, childCategories = _props.childCategories, CurrentIndex = _props.CurrentIndex, application = _props.application, applicationLabel = _props.applicationLabel, masterProvider = _props.masterProvider, geolocation = _props.geolocation;
                var isLoadingCategory = this.state.isLoadingCategory;
                var productslength = category.products ? category.products.length ? category.products.length : 0 : 0;
                if (!childCategories[CurrentIndex] || childCategories[CurrentIndex].length == 0 && productslength == 0) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "page empty-results",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateLocationModal, {
                                title: "Update Your Location",
                                open: this.state.showAddressModal,
                                hideModal: function() {
                                    _this.setState({
                                        showAddressModal: false
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "info",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            className: "page-title",
                                            children: isLoadingCategory ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fas fa-circle-notch fa-spin mr-2"
                                                    }),
                                                    "Loading Please Wait..."
                                                ]
                                            }) : !geolocation.latitude ? "Location is Required to Show Products." : "Items not Available".concat(applicationLabel ? " for your ".concat(applicationLabel) : "", " and Area Online.")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "help",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "Need help? Here is what you can do"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "help-elements",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "help-element",
                                                            href: "tel:+18002288379",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fas fa-phone"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Call help at 1-800-228-8379"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            className: "help-element",
                                                            href: "mailto:info@1800battery.com?Subject=Inquiry%20from%20Website",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fas fa-envelope",
                                                                    "aria-hidden": "true"
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Get in touch with our support"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                            className: "help-element",
                                                            onClick: function() {
                                                                _this.setState({
                                                                    showAddressModal: true
                                                                });
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fas fa-map-marker-alt"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: "Change Your Location"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
                var name = "1-800-Battery";
                if (masterProvider && masterProvider.isActive) {
                    name = masterProvider.name;
                }
                var hostname = "1800battery.com";
                if (true) {
                    hostname = window.location.hostname;
                }
                var canonical = "https://".concat(hostname, "/category/").concat(this.props.categoryid);
                // In case crawler somehow reaches duplacate pages, don't index. We recognize those pages because they have ID number instead of id string
                var noindex = !isNaN(this.props.categoryid);
                var fullCategoryName = "";
                this.props.breadcrumbs.forEach(function(element, index) {
                    if (_this.props.breadcrumbs.length <= 3) {
                        if (index >= 1) {
                            fullCategoryName = fullCategoryName + (index === 2 ? " for " : " ") + element.name;
                        }
                    } else {
                        if (index != 0 && index != 2) {
                            fullCategoryName = fullCategoryName + (index === 3 ? " for " : " ") + element.name;
                        }
                    }
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                            title: "".concat(fullCategoryName ? fullCategoryName : "Get a new batery", "| ").concat(name),
                            canonical: canonical,
                            noindex: noindex,
                            // description={category ? category.name && category.description + ' for ' : '' && applicationLabel}
                            description: "Roadside and onsite battery assistance services, combined with a nationwide support system for warranty and support."
                        }),
                        this.renderBreadCrumb(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "page collection",
                            children: this.renderMainArea()
                        }),
                        this.props.roadside && this.props.roadside.request || this.props.category && this.props.categoryid == 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyBulletPoints/* default */.Z, {
                                masterProvider: this.props.masterProvider,
                                title: this.props.roadside && this.props.roadside.request ? "Jumpstart Upgrade" : "Why Choose Us"
                            })
                        }) : ""
                    ]
                });
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(param) {
                var res = param.res, req = param.req, store = param.store, _query = param.query, categoryid = _query.categoryid, cityUrl = _query.cityUrl, ctx = param.ctx;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var updateGeolocation, geolocationPayload, parsedUrl, slug, _query, crit, rsrequestid, initState, payload;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                updateGeolocation = false;
                                geolocationPayload = null;
                                // await store.dispatch(getAllServices());
                                if (categoryid == null) {
                                    if (req) {
                                        parsedUrl = queryString.parseUrl(req.url);
                                        slug = parsedUrl.url.split("/");
                                        categoryid = slug[2];
                                        if (slug.length >= 4) {
                                            cityUrl = slug[3];
                                        }
                                        _query = parsedUrl.query, crit = _query.crit, rsrequestid = _query.rsrequestid;
                                    }
                                }
                                if (!rsrequestid) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    store.dispatch((0,actions/* getRoadsideRequest */.bD)(rsrequestid))
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                initState = store.getState();
                                if (!(initState.countries.countries.length == 0)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    store.dispatch((0,actions/* getAllCountries */.v9)())
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                if (!cityUrl) return [
                                    3,
                                    7
                                ];
                                return [
                                    4,
                                    (0,utils_geolocation/* fetchCritAndZip */.Ic)(cityUrl, false)
                                ];
                            case 5:
                                payload = _state.sent();
                                return [
                                    4,
                                    geolocation/* setLocation */.l6(payload)
                                ];
                            case 6:
                                _state.sent();
                                _state.label = 7;
                            case 7:
                                return [
                                    4,
                                    store.dispatch((0,actions/* getCategoryProps */.tn)(categoryid))
                                ];
                            case 8:
                                _state.sent(); // Geolocation will update in Mounting to avoid multi-calls and cookie collision
                                return [
                                    2,
                                    {
                                        categoryid: categoryid,
                                        crit: crit,
                                        cityUrl: cityUrl,
                                        updateGeolocation: updateGeolocation,
                                        geolocationPayload: geolocationPayload
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Category;
}(page/* default */.Z);
(0,_define_property/* default */.Z)(Category, "propTypes", {
    isLoadingCategory: (prop_types_default()).bool,
    mainCategory: (prop_types_default()).object,
    childCategories: (prop_types_default()).array,
    featuredCategories: (prop_types_default()).array,
    categoryid: (prop_types_default()).string,
    breadcrumbs: (prop_types_default()).array,
    CurrentIndex: (prop_types_default()).number,
    products: (prop_types_default()).array,
    application: (prop_types_default()).array,
    applicationLabel: (prop_types_default()).string,
    currentLevelQuery: (prop_types_default()).string
});
// const childCategories = getFitmentModelsNoStore(this.props.router.query.categoryid);
var mapStateToProps = function(state) {
    return {
        geolocation: state.geolocation,
        relatedProducts: state.category.relatedProducts,
        products: state.category.products,
        category: state.category,
        applicationBreadcrumbs: state.category.breadcrumbs,
        application: state.category.application,
        applicationLabel: state.category.applicationLabel,
        breadcrumbs: state.category.breadcrumbs,
        childCategories: state.category.childCategories,
        CurrentIndex: state.category.CurrentIndex,
        featuredCategories: state.category.featuredCategories,
        currentLevelQuery: state.category.currentLevelQuery,
        productServices: state.category.services,
        provider: state.provider,
        countries: state.countries.countries,
        masterProvider: state.masterProvider,
        IsLocationRequired: !(state.geolocation && state.geolocation.formatted_address),
        priceLevel: state.pricelevel.priceLevel,
        roadside: state.roadside,
        reviews: state.reviews
    };
};
var mapDispatchToProps = {
    getAllCategories: actions/* getAllCategories */.tG,
    getAllServices: actions/* getAllServices */.UV,
    getCategoryProps: actions/* getCategoryProps */.tn,
    setVin: actions/* setVin */.PF,
    setNavigation: actions/* setNavigation */.An,
    setSelectedProvider: actions/* setSelectedProvider */.QV,
    setLocation: geolocation/* setLocation */.l6,
    getRoadsideRequest: actions/* getRoadsideRequest */.bD
};
/* harmony default export */ var _param_ = ((0,withPage/* default */.ZP)((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(Category)));


/***/ }),

/***/ 63928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);









var CategoryBreadcrumb = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CategoryBreadcrumb, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CategoryBreadcrumb);
    function CategoryBreadcrumb() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, CategoryBreadcrumb);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(CategoryBreadcrumb, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, category = _props.category, breadcrumbs = _props.breadcrumbs;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "breadcrumb-section",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "page-title",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: category.name
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-12 col-md-12 col-lg-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                                        "aria-label": "breadcrumb",
                                        className: "theme-breadcrumb",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                                            className: "breadcrumb",
                                            children: breadcrumbs ? breadcrumbs.map(function(item, i) {
                                                var url = "";
                                                for(var j = 1; j <= i; j++){
                                                    var valueToInject = breadcrumbs[j].name === "Hybrid or Electric" ? "hybrid-electric" : breadcrumbs[j].name;
                                                    url += valueToInject.replace(/\./g, "-").toLowerCase() + "-";
                                                }
                                                url = url.replace(/\s/g, "-").slice(0, -1);
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: "breadcrumb-item",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                        href: item.id == 0 ? "/" : "/category/[category]",
                                                        as: item.id == 0 ? "/" : "/category/".concat(url),
                                                        prefetch: false,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            children: item.name
                                                        })
                                                    })
                                                }, i);
                                            }) : category.name
                                        })
                                    })
                                })
                            ]
                        })
                    })
                });
            }
        }
    ]);
    return CategoryBreadcrumb;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(CategoryBreadcrumb, "propTypes", {
    category: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().object),
    breadcrumbs: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().array)
});
/* harmony default export */ __webpack_exports__["Z"] = (CategoryBreadcrumb);


/***/ }),

/***/ 76216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_components_home_PlacesSearch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69174);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var LocationRequiredOverlay = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "location-required-overlay on-category",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "inner",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "icon-container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-exclamation-circle"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "content-container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Location Required"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: "Our products and service availability are dependent on where you are located."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_home_PlacesSearch__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            isModalOpen: false,
                            hasMyLocationButton: true
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LocationRequiredOverlay);


/***/ }),

/***/ 83407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ collator; },
/* harmony export */   "q": function() { return /* binding */ groupByAlpha; }
/* harmony export */ });
var collator = new Intl.Collator("en", {
    numeric: true,
    sensitivity: "base"
});
var groupByAlpha = function(AllData, SortBy) {
    var groupedCollection = {};
    var arr_length = AllData ? AllData.length : 0;
    if (arr_length > 0) {
        AllData.sort(function(a, b) {
            if (SortBy === "Asc") return collator.compare(a.name, b.name);
            else return collator.compare(b.name, a.name);
        });
    }
    for(var i = 0; i < arr_length; i++){
        var firstLetter = AllData[i].name.charAt(0);
        if (groupedCollection[firstLetter] === undefined) {
            groupedCollection[firstLetter] = [];
        }
        groupedCollection[firstLetter].push({
            id: AllData[i].id,
            name: AllData[i].name,
            urlSlug: AllData[i].urlRedirect != null ? AllData[i].urlRedirect : AllData[i].urlSlug,
            sortOrder: AllData[i].sortOrder
        });
    }
    return groupedCollection;
};


/***/ }),

/***/ 65727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ category_WhyBulletPoints; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/static/images/icon/landing/fitment.svg
/* harmony default export */ var fitment = ({"src":"/_next/static/media/fitment.b7b7aced.svg","height":640,"width":640});
;// CONCATENATED MODULE: ./src/static/images/icon/landing/free-shipping.svg
/* harmony default export */ var free_shipping = ({"src":"/_next/static/media/free-shipping.573543fb.svg","height":640,"width":640});
;// CONCATENATED MODULE: ./src/static/images/icon/landing/jumpstart.svg
/* harmony default export */ var jumpstart = ({"src":"/_next/static/media/jumpstart.0ac6e70c.svg","height":512,"width":512});
;// CONCATENATED MODULE: ./src/static/images/icon/landing/special-online-prices.svg
/* harmony default export */ var special_online_prices = ({"src":"/_next/static/media/special-online-prices.799b8e85.svg","height":512,"width":512});
;// CONCATENATED MODULE: ./src/static/images/icon/landing/warranty.svg
/* harmony default export */ var warranty = ({"src":"/_next/static/media/warranty.9b3e2934.svg","height":512,"width":512});
;// CONCATENATED MODULE: ./src/components/category/WhyBulletPoints/index.js








var WhyBulletPoints = function(props) {
    var title = props.title, masterProvider = props.masterProvider;
    if (masterProvider && masterProvider.isActive == true) {
        return "";
    }
    var titleMastHead = title ? title : "Why Choose Us";
    var priceMessage = "Cheaper then any Dealership";
    if (titleMastHead == "Jumpstart Upgrade") {
        priceMessage = "Batteries over 2 years old and require a jumpstart need a battery over 40% of the time.  Save Now!";
    }
    return props.isVertical ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "why-1800-battery v2 vertical",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Why Choose 1800Battery"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas fa-check-circle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: priceMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas fa-check-circle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: "Installation is included in Price"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas fa-check-circle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: "Home of the JumpStart Guarantee"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas fa-check-circle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: "Correct Battery Guaranteed*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "*"
                    }),
                    " - Additional Fees May Apply"
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "why-1800-battery v2 ".concat(props.isVertical ? "vertical" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: titleMastHead
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "64px",
                                        height: "64px",
                                        src: special_online_prices,
                                        alt: "Special Online Only Prices"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: priceMessage
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "64px",
                                        height: "64px",
                                        src: warranty,
                                        alt: "Warranty"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: "National Warranty Support"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "64px",
                                        height: "64px",
                                        src: free_shipping,
                                        alt: "Free Shipping"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: "Installation is included in Price"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "64px",
                                        height: "64px",
                                        src: jumpstart,
                                        alt: "JumpStart Guarantee"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: "For Mobile Delivery of Car Batteries - Home of the “JumpStart Guarantee“"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "64px",
                                        height: "64px",
                                        src: fitment,
                                        alt: "Fitment Guarantee"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: "Correct Battery Guaranteed* - We will make sure its the right battery!"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                className: "text-center mt-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas fa-info-circle"
                    }),
                    " Additional fees may apply"
                ]
            })
        ]
    });
};
/* harmony default export */ var category_WhyBulletPoints = (WhyBulletPoints);


/***/ }),

/***/ 2277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rU": function() { return /* reexport */ utils_link; },
  "xf": function() { return /* reexport */ CategoryUrl; },
  "AK": function() { return /* reexport */ ClassNames; },
  "vn": function() { return /* reexport */ HtmlToReact; },
  "gI": function() { return /* reexport */ Markdownify; },
  "o2": function() { return /* reexport */ PostUrl; },
  "JF": function() { return /* reexport */ SafePrefix; }
});

// UNUSED EXPORTS: withPrefix

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/utils/classNames.js


// TODO: why do we need this? (V.T. 20.12.2021)
function ClassNames() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _classNames;
    return (_classNames = (classnames_default())).call.apply(_classNames, [
        this
    ].concat((0,_to_consumable_array/* default */.Z)(args))) || null;
}

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
;// CONCATENATED MODULE: ./src/utils/htmlToReact.js


// TODO: why do we need this? (V.T. 20.12.2021)
function HtmlToReact(html) {
    if (!html) {
        return null;
    }
    return (0,lib/* default */.ZP)(html, {
        transform: function(node) {
            if (node.type === "script") {
                if (!isEmpty_default()(node.children)) {
                    return "";
                } else {
                    return "";
                }
            }
        }
    });
}

// EXTERNAL MODULE: ./node_modules/marked/lib/marked.esm.js
var marked_esm = __webpack_require__(87441);
;// CONCATENATED MODULE: ./src/utils/markdownify.js


function Markdownify(markdown) {
    if (!markdown) {
        return null;
    }
    return HtmlToReact(marked_esm/* marked.parse */.TU.parse(markdown));
}

// EXTERNAL MODULE: ./node_modules/lodash/startsWith.js
var startsWith = __webpack_require__(10240);
var startsWith_default = /*#__PURE__*/__webpack_require__.n(startsWith);
;// CONCATENATED MODULE: ./src/utils/safePrefix.js

var withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
function SafePrefix(url) {
    if (startsWith_default()(url, "#") || startsWith_default()(url, "http")) {
        return url;
    }
    return withPrefix(url);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/utils/link.js






var Link = function(_param) {
    var children = _param.children, href = _param.href, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "href"
    ]);
    // Pass Any internal link to Next.js Link, for anything else, use <a> tag
    var internal = /^\/(?!\/)/.test(href);
    // For root page, use index.js, for rest use [...slug].js
    var page = href === "/" ? "/" : "/[...slug]";
    var slug = href.split("/");
    if (slug.length > 2) {
        if (slug[1] == "category") {
            page = "/category/[categoryid]?categoryid=".concat(slug[2]);
        }
        if (slug[1] == "product") {
            page = "/product/[productid]?productid=".concat(slug[2]);
        }
    }
    if (internal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: page,
            as: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
                children: children
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: href
    }, other), {
        children: children
    }));
};
/* harmony default export */ var utils_link = (Link);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/trim.js
var trim = __webpack_require__(92742);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
;// CONCATENATED MODULE: ./src/utils/postUrl.js


var postUrl_withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
function PostUrl(post) {
    var slug = trim_default()(get_default()(post, "slug"), "/");
    return postUrl_withPrefix("/blog/".concat(slug));
}

;// CONCATENATED MODULE: ./src/utils/categoryUrl.js


var categoryUrl_withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
// TODO: Generalize function and reuse (V.T. 31.1.2022)
function CategoryUrl(category) {
    var slug = trim_default()(get_default()(category, "slug"), "/");
    return categoryUrl_withPrefix("/blog/category/".concat(slug));
}

// EXTERNAL MODULE: ./src/utils/withPrefix.js
var utils_withPrefix = __webpack_require__(15629);
;// CONCATENATED MODULE: ./src/utils/index.js










/***/ }),

/***/ 15629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WithPrefix; }
/* harmony export */ });
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98392);
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_trimStart__WEBPACK_IMPORTED_MODULE_0__);

function WithPrefix(url) {
    var basePath = "";
    return basePath + "/" + lodash_trimStart__WEBPACK_IMPORTED_MODULE_0___default()(url, "/");
}


/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ })

}]);